export default __webpack_public_path__ + "static/media/adsform-sec3-bg-big.21a76952.jpg";